import { Car, Flame, Scissors } from "lucide-react";
import { cn } from "@/lib/utils";
import { PlaceholderTag } from "@/components/site/Bits";

export const PROJECT_ICONS = { Flame, Car, Scissors };

export const ConceptThumb = ({ project, className }) => {
  const Icon = PROJECT_ICONS[project.icon] ?? Flame;
  return (
    <div
      role="img"
      aria-label={`Preview card for ${project.name}, a fictional ${project.industry.toLowerCase()} business. Screenshot coming soon.`}
      className={cn("relative aspect-[4/3] overflow-hidden rounded-xl border border-white/[0.08] bg-[#0E1015] md:aspect-square lg:aspect-[4/3]", className)}
    >
      <div className="hatch absolute inset-0" />
      <div
        className="absolute inset-0 transition-transform duration-700 ease-out group-hover:scale-110"
        style={{ background: `radial-gradient(65% 65% at 75% 15%, ${project.accent}38, transparent 70%)` }}
      />
      <div className="absolute inset-x-0 top-0 flex items-center gap-1.5 border-b border-white/[0.06] bg-black/25 px-3 py-2">
        <span className="h-2 w-2 rounded-full bg-white/15" />
        <span className="h-2 w-2 rounded-full bg-white/15" />
        <span className="h-2 w-2 rounded-full bg-white/15" />
        <PlaceholderTag className="ml-auto">Image placeholder</PlaceholderTag>
      </div>
      <div className="absolute inset-0 flex flex-col justify-end p-5">
        <span className="grid h-10 w-10 place-items-center rounded-lg" style={{ backgroundColor: `${project.accent}22`, color: project.accent }}>
          <Icon className="h-5 w-5" aria-hidden="true" />
        </span>
        <p className="mt-4 text-2xl font-semibold tracking-tight text-white">{project.short}</p>
        <p className="text-sm text-white/65">{project.industry}</p>
      </div>
    </div>
  );
};
